<template lang="pug">
    el-dialog(title="查看照片打卡",width="95%",:visible.sync='visible' :append-to-body="true")
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 分级公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                    div.width_label(v-if="ruleForm.ctType === 1") 常规赛
                    div.width_label(v-if="ruleForm.ctType === 2") 月度赛
                    div.width_label(v-if="ruleForm.ctType === 3") 季度赛
                    div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="比赛项目" prop="projectType")
                    div.width_label(v-if="ruleForm.projectType === 1") 单打
                    div.width_label(v-if="ruleForm.projectType === 2") 双打
                el-form-item(label="级别" prop="level")
                    div.width_label {{ruleForm.level}}
                el-form-item(label="签位" prop="applySize")
                    div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                br
                el-form-item(label="比赛时间")
                    div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                //- el-form-item(v-if="ruleForm.projectType === 2" label="排序")
                //-     el-select(v-model="ruleForm.orderForm" @change="orderChange")
                //-         el-option(label="按级别和-积分和" :value=1 )
                //-         el-option(label="按级别差-积分和" :value=2 )
        el-row(style="padding-top:10px")
            el-col(:span="24")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 打卡照片
                    div
                    div(slot="header")
                        img(:src='item.photoUrl' v-for="(item,index) in photo" style="width:240px;height:174px;margin-right:20px")
                    div

        span.dialog-footer(slot="footer")
            //- el-button(@click="comfirmClick" type="primary") 确 定
            el-button(@click="closeWind") 取 消
</template>
<script>
export default {
    data () {
        return {
            visible: false,
            ruleForm: {

            },
            datafrom: {
                ctId: '',
                againstId: '',
                doublesSort: '',
                round: '',
                firstGroup: ''
            },
            gradeData: [],
            loading: null,
            isRoundView: true,
            photo: [],
            updateGradeVisible: false,
            viewDisputeVisible: false,
            viewPhotosVisible: false,
            matchGameData: [], // 对阵表数据
            gameRankData: [] // 排行榜数据
        }
    },
    methods: {
        init (ctId, againstId, id, doublesSort, round, firstGroup) {
            console.log(ctId, againstId, id)
          this.datafrom.ctId = ctId
          this.datafrom.againstId = againstId
          this.datafrom.doublesSort = doublesSort
          this.datafrom.round = round
          this.datafrom.firstGroup = firstGroup
            this.visible = true
            this.gradeData = null
            //回显
            this.$http({
                url: this.$http.adornUrl(`/weChat/referee/queryClockPhoto`),
                method: 'post',
                data: this.datafrom
            }).then((data) => {
                if (data.data != null && data.code === 0) {
                  this.photo = data.data
                } else {
                  this.photo = []
                }
            }).then(() => {

            })
            this.$http({
                url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
                method: 'get'
            }).then((data) => {
                if (data && data.code === 0) {
                    this.ruleForm = data.bean
                    let joinCount = this.ruleForm.joinCount//已报名参赛人员的人数
                    let applySize = this.ruleForm.applySize//赛事签位数
                    let date1 = new Date().getTime()
                    let date2 = new Date(this.ruleForm.matchStartTime).getTime()
                    let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
                    let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
                    if (date1 < date3) {
                        this.ruleForm.statusName = '未开始'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount < applySize) {
                        this.ruleForm.statusName = '报名中'
                    } else if (date1 >= date3 && date1 <= date4 && joinCount >= applySize) {
                        this.ruleForm.statusName = '报满可替'
                    } else if (date1 > date4 && date1 < date2) {
                        this.ruleForm.statusName = '报名结束'
                    } else if (date1 >= date2) {
                        this.ruleForm.statusName = '已开赛'
                    }
                    this.ruleForm.orderForm = 1
                }
            }).then(() => {

            })
        },
        openFullScreen () {
            this.loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
        },
        closeWind () {
          this.visible = false
          this.$emit('GradeVisible')
        }
    }
}
</script>
<style scoped>
.active {
        background: #02B90D !important;
        color:#fff !important;
}
.marginBottom {
    margin-bottom: 20px;
}
</style>
